'use client';

import CustomFiltersIcon from '@/components/icons/customFiltersIcon';
import { IconButton } from '@/components/ui/iconButton';
import { FILTERS_DRAWER_TRIGGER_ID } from '@/constants';
import { useProductListSelectedFiltersCount } from '@/features/products/state/list/context';
import { replacePlaceholders } from '@/i18n';
import { listingTranslate } from '@/i18n/translations/listingTranslations';

export const ProductFiltersButton = () => {
  const selectedFiltersCount = useProductListSelectedFiltersCount();

  return (
    <IconButton
      component="label"
      htmlFor={FILTERS_DRAWER_TRIGGER_ID}
      tabIndex={-1}
      aria-hidden="true"
      className="bg-(--mui-palette-common-white_states-main) rounded-lg text-left justify-start shadow-xs cursor-pointer mobile-filters-trigger grow"
    >
      <CustomFiltersIcon className="text-(--mui-palette-primary-light) m-1.5 size-6 mr-0" />
      {!selectedFiltersCount ? (
        <p className="text-sm ml-2 capitalize font-bold text-(--mui-palette-text-primary)">
          {listingTranslate('filters.button')}
        </p>
      ) : (
        <p className="text-sm ml-2 capitalize font-bold text-(--mui-palette-text-primary)">
          {replacePlaceholders(listingTranslate('filters.button.text'), {
            value: selectedFiltersCount
          })}
        </p>
      )}
    </IconButton>
  );
};
